import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { SuperEvent } from 'super-events/types'

const useGetSuperEvent = (): [(id: number) => Promise<SuperEvent>, Status<SuperEvent>] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<SuperEvent>()

  const getSuperEvent = useCallback(
    (id: number) => {
      return request({
        method: 'get',
        url: `/organizations/${organization.id}/super_events/${id}`,
      })
    },
    [organization.id, request],
  )

  return [getSuperEvent, status]
}

export default useGetSuperEvent
